module.exports = __webpack_public_path__ + "public/img/jiank.be11407a.jpg";